import React, {useState} from "react";
import { InputComponent } from "../../common/InputComponent/InputComponent";
import { useFormik, FormikHelpers } from "formik";
import * as Yup from "yup"
import { axiosClient } from "../../../services/axiosClient";
import { useNavigate } from "react-router-dom";
import { forgetPassword } from "../../../services/api";

interface Values {
    email:string,
}

interface MsgObject {
    Msg: string,
    Status: string,
}

const resetPasswordSchema= ()=>Yup.object().shape({
    email:Yup.string().email("Email must be valid").required("Email is required"),
  })

const ForgetPassword : React.FC = ()=> {

    const navigate = useNavigate();

    const handleResetPassword = async (values:Values,{resetForm}:FormikHelpers<Values>)=> {
        let res:any = await forgetPassword(values)  
        if(res.status==200){
            {setresetPasswordMsg({Msg:res.data.message, Status:'success'})}
        } else {
            setresetPasswordMsg({Msg:res.data.message, Status:'failed'})
        }
    }

    const [resetPasswordMsg, setresetPasswordMsg] = useState<MsgObject>({Msg:'', Status: ""})

    const formik = useFormik({
        initialValues:{ email: ""},
        validationSchema:resetPasswordSchema,
        validateOnChange:false,
        onSubmit:handleResetPassword
      })

    return (
        <div className="min-h-screen min-w-full flex flex-col">
            <div>
                <div className="p-2 ml-6">
                    <div className="w-22 py-2 ml-6">
                        <img src="/images/logo.png" alt="taotensor" />
                    </div>
                </div>
            </div>
            <div className="min-w-500 flex justify-center items-center px-12 flex-1">
                <form onSubmit={formik.handleSubmit} className="min-w-500 px-12 mb-4">
                    <div className="flex items-center mb-3">
                        <h4 className="custom-font text-4xl text-mid-gray">Forget Password</h4>
                    </div>
                    <div className="pt-4 flex flex-col">
                        <InputComponent
                            type="text"
                            value={formik.values.email}
                            name="email"
                            error={formik.errors.email}
                            showErrorMessage
                            onChange={formik.handleChange}
                            labelText={"Email"}
                            />
                        <button type="submit" className="mt-4 custom-font bg-primary rounded-full border-1 border-black text-button-text p-1 hover:bg-secondary hover:text-button-text-hover transition duration-300 ease-in-out">
                            Reset Passowrd
                        </button>
                        {resetPasswordMsg.Msg && resetPasswordMsg.Msg!='' && <p className={`text-sm pt-2 ${resetPasswordMsg.Status == 'success' ? 'text-green' : 'text-red'}`}>{resetPasswordMsg.Msg}</p>}
                        <button onClick={()=>navigate("/login")} className="mt-4 custom-font bg-white rounded-full border-1 border-black text-black p-1 hover:bg-gray-200 transition duration-300 ease-in-out">
                            Go Back To Sign In
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ForgetPassword